import { BadgeVariant } from "ds/components/Badge/types";

type IntentProjectStateBadgeMeta = {
  variant: BadgeVariant;
  label: string;
};

export const getIntentProjectStateBadgeMeta = (state: string): IntentProjectStateBadgeMeta => {
  switch (state) {
    case "READ_WRITE":
      return { variant: BadgeVariant.green, label: "Read / Write" };
    case "READ_ONLY":
      return { variant: BadgeVariant.yellow, label: "Read Only" };
    case "NONE":
    default:
      return { variant: BadgeVariant.gray, label: "None" };
  }
};
